import { createFileRoute } from '@tanstack/react-router'
import AdministrationClients from 'Administration/containers/AdministrationClientsContainer'
import { Suspense } from 'react'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard, adminClaims } from '../../-guard'

export const Route = createFileRoute('/administration/clients/')({
    component: () => (
        <Guard claims={adminClaims}>
            <Suspense fallback={<PageSkeleton variant="grid" wrapper="page" />}>
                <AdministrationClients />
            </Suspense>
        </Guard>
    ),
})
